<button type="button" class="bw-indicator"
        [class.bw-indicator--loading]="loading()"
        [attr.title]="tooltip()"
        [attr.aria-label]="ariaLabel()"
        [attr.aria-busy]="loading()"
        data-test-id="birth-window-indicator"
        (click)="openRequested.emit()">
  @for (segment of segments(); track segment.tier) {
    <span class="bw-indicator__segment"
          [class.bw-indicator__segment--red]="segment.color === 'red'"
          [class.bw-indicator__segment--orange]="segment.color === 'orange'"
          [class.bw-indicator__segment--yellow]="segment.color === 'yellow'"
          [class.bw-indicator__segment--green]="segment.color === 'green'"
          [class.bw-indicator__segment--unknown]="segment.color === 'unknown'"
          [class.bw-indicator__segment--critical]="segment.critical">
      @if (segment.critical) {
        <i class="fas fa-exclamation" aria-hidden="true"></i>
      }
    </span>
  }
  <i class="fas fa-hourglass-half bw-indicator__icon" aria-hidden="true"></i>
</button>
